<template>
  <UiIcon
    name="menu"
    size="var(--size-typography-size-24)"
    :is-clickable="true"
    v-bind="$attrs"
    @click="toggleMenu"
  />
  <Transition name="fade">
    <div class="backdrop" @click="toggleMenu" v-show="toDisplayModal" />
  </Transition>
  <Transition name="slide-side">
    <div class="sidebar-menu-slider" v-show="toDisplayModal">
      <slot name="content" />
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { ref, watch, onBeforeUnmount } from 'vue'
import UiIcon from '@sephora-asia/ui-icon/UiIcon.vue'

interface Emits {
  (e: 'display-modal', value: boolean): void
}

const emit = defineEmits<Emits>()

const emitDisplayModal = function (): void {
  emit('display-modal', toDisplayModal.value)
}

const toDisplayModal = ref(false)

function toggleMenu(): void {
  toDisplayModal.value = !toDisplayModal.value
  emitDisplayModal()
}

const BG_SCROLL_LOCK_CLASS = 'background-scroll-locked'

watch(toDisplayModal, (visible: boolean) => {
  if (visible) {
    document.body.classList.add(BG_SCROLL_LOCK_CLASS)
  } else {
    document.body.classList.remove(BG_SCROLL_LOCK_CLASS)
  }
})

onBeforeUnmount(() => {
  document.body.classList.remove(BG_SCROLL_LOCK_CLASS)
})
</script>

<style lang="scss" scoped>
:global(body.background-scroll-locked) {
  overflow: hidden;
}

.sidebar-menu-slider {
  background-color: var(--color-background-base); // To not have opacity
  bottom: 0;
  display: flex;
  flex-flow: row nowrap;
  left: 0;
  position: fixed;
  top: 0;
  width: 88%;
  z-index: var(--size-z-index-modal);
}

.backdrop {
  background-color: var(--color-base-black);
  cursor: pointer;
  height: 100%;
  opacity: 0.6;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: var(--size-z-index-modal-backdrop);
}

.slide-side-enter-active {
  transition: all 0.5s ease-out;
}

.slide-side-leave-active {
  transition: all 0.3s ease-out;
}

.slide-side-enter-from {
  bottom: 0;
  left: 0;
  position: fixed;
  top: 0;
  transform: translateX(-88%);
}
.slide-side-leave-to {
  transform: translateX(-100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
